class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    // Dawn normally expects parsedState.key, but your response doesn't include it.
    this.cartItemKey = parsedState && parsedState.key ? parsedState.key : null;

    this.getSectionsToRender().forEach((section) => {
      const targetEl = document.getElementById(section.id);
      if (!targetEl) return;

      const html = parsedState && parsedState.sections ? parsedState.sections[section.id] : '';
      if (!html) return;

      // Special handling for product area: keyless fallback
      if (section.id === 'cart-notification-product') {
        const keySelector = this.cartItemKey ? `[id="cart-notification-product-${this.cartItemKey}"]` : null;

        let inner = '';
        if (keySelector) inner = this.getSectionInnerHTML(html, keySelector);
        if (!inner) inner = this.getSectionInnerHTML(html, '.cart-item');
        if (!inner) inner = html; // ultimate fallback

        targetEl.innerHTML = inner;
        return;
      }

      // Default handling (button + cart bubble)
      targetEl.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        // selector will be handled dynamically in renderContents (because key may be null)
        selector: '',
      },
      {
        id: 'cart-notification-button',
        selector: '#cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    // If no selector, return full html
    if (!selector) return html;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);

    // fallback: don't crash if selector not found
    if (!el) return html;
    return el.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
